module.exports = __webpack_public_path__ + "media/118.a1525f23.wav";